export default __webpack_public_path__ + "static/media/peopleIcon.ebad78cd.svg";